import type { EmailContact } from "@stockline/shared/types/communications/email-contact"
import type { OfflineResourceConfig } from "../../../types"
import { EMAIL_CONTACT_TABLE } from "./db"

export const emailContactConfig: OfflineResourceConfig<EmailContact> = {
  name: "email-contacts",
  // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
  // scope change (STK-1238).
  groupScoped: true,
  endpoints: {
    full: "/api/v2/email-contacts",
    delta: "/api/v2/email-contacts/changes",
    push: "/api/v2/email-contacts/changes",
  },
  tableName: EMAIL_CONTACT_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    emailAddress: "emailAddress",
    domain: "domain",
    emailAccountId: "emailAccountId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
